import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './rootReducer';

// Define the root state type
export type RootState = ReturnType<typeof store.getState>;

// Define persist configurations
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['user', 'navItems'], // Persist both to avoid breaking functionality
  blacklist: ['confirMdl'], // ⚡ Don't persist confirMdl (it has functions)
  throttle: 100,
};

// Wrap root reducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'confirMdl/setConfirmation', // ⚡ Ignore the action that has functions
        ],
        ignoredActionPaths: [
          'payload.onYes', // ⚡ Ignore function in action payload
          'payload.onNo',
        ],
        ignoredPaths: [
          'confirMdl.onYes', // ⚡ Ignore functions in state
          'confirMdl.onNo',
        ],
      },
      // ⚡ Disable immutability check in production for speed
      immutableCheck: false, // Disable entirely - it's the slowest middleware
    }),
});

// ⚡ Create persistor without blocking (runs async)
export const persistor = persistStore(store, null, () => {
  console.log('✅ Redux rehydration complete');
});

export default store;
